import { render, staticRenderFns } from "./NTP.vue?vue&type=template&id=93eedb30&scoped=true"
import script from "./NTP.vue?vue&type=script&lang=js"
export * from "./NTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93eedb30",
  null
  
)

export default component.exports